import { useState, useEffect } from 'react';
import { getCurrentLanguage, setLanguage, onLanguageChange, t as translate } from '../utils/i18n';

/**
 * Translation Hook
 * Provides translation function and language state
 */
export function useTranslation() {
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());

  useEffect(() => {
    const unsubscribe = onLanguageChange(setCurrentLang);
    return unsubscribe;
  }, []);

  // Use the imported translate function directly
  const t = (key, params = {}) => {
    return translate(key, params);
  };

  return {
    t,
    currentLanguage: currentLang,
    setLanguage
  };
}
